import { render, staticRenderFns } from "./NavigationPanel.vue?vue&type=template&id=2e5ace8a&"
import script from "./NavigationPanel.vue?vue&type=script&lang=ts&"
export * from "./NavigationPanel.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationPanel.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports